
import MenuIcon from '@mui/icons-material/Menu'
import _AppBar from '@mui/material/AppBar'

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBuildingColumns, faCreditCard, faMoon } from '@fortawesome/free-solid-svg-icons'

import React, { Fragment as F,
  useContext, useEffect, useLayoutEffect, useRef, useState,
} from 'react'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Popover from 'react-bootstrap/Popover';
import Tooltip from 'react-bootstrap/Tooltip'
import { useKeycloak } from '@react-keycloak/web'
import Modal from 'react-modal'
import {
  Link,
  BrowserRouter as Router,
  Route,
  Routes,
  useParams,
} from "react-router-dom"
import Select from 'react-select'

import config from 'config'

import {
  appRouter,
  C,
  logg,
  useApiRouter,
} from '$shared'
import {
  AppCtx,
} from '../App'
import {
  BanksCtx,
} from './banks'
import {
  FintegrationCtx,
} from './fintegration'
import {
  PeriodsCtx,
} from './periods'
import {
  QueriesCtx,
} from './queries'
import {
  ReportsCtx,
} from './reports'

const themeLabels = {
  'theme-eagle': 'Fedfis Theme',
  'theme-dark': 'Dark Theme',
  'theme-light': 'Light Theme',
}

/*
 * MainMenu
**/
const MainMenu = (props) => {
  // logg(props, 'main menu')

  const apiRouter = useApiRouter()

  // logg(appRouter, 'appRouter')

  /* ctx */

  const {
    actionName, setActionName,
    cuEmail,
    drawerOpen, setDrawerOpen,
    joyrideOpen, setJoyrideOpen,
    joyrideRun, setJoyrideRun,
    joyrideStepIdx, setJoyrideStepIdx,
    logout,
    params: {
      schedule_id,
    },
    themeName, nextTheme,
    unauthorized, setUnauthorized,
  } = useContext(AppCtx)
  // logg(useContext(AppCtx), 'AppCtx in MainMenu')

  const {
    bank,
            setBanksSearchModalOpen,
            setResults,
  } = useContext(BanksCtx)
  // logg(useContext(BanksCtx), 'BanksCtx in MainMenu')

  const {
    fintegrationSearchModalOpen, setFintegrationSearchModalOpen,
  } = useContext(FintegrationCtx)
  // logg(useContext(FintegrationCtx), 'FintegrationCtx in MainMenu')

  const {
    selectedPeriods,
    setPeriodsModalOpen,
  } = useContext(PeriodsCtx)
  // logg(useContext(PeriodsCtx), 'PeriodsCtx in MainMenu')

  const {
    setQueriesModalOpen,
  } = useContext(QueriesCtx)

  const {
    setAdvancedReportsModalOpen,
    setReportsModalOpen,
  } = useContext(ReportsCtx)
  // logg(useContext(ReportsCtx), 'ReportsCtx in MainMenu')

  /* state */

  const [ logoutModalOpen, setLogoutModalOpen ] = useState(false)

  const [ quickExportPath, setQuickExportsPath ] = useState()
  useEffect(() => {
    if (actionName === C.actions['banks#contacts']) {
      setQuickExportsPath(apiRouter.bankContactsPath({ rssd: bank.rssd, format: 'csv' }))
    }
    if (actionName === C.actions['banks#schedule']) {
      setQuickExportsPath(apiRouter.bankSchedulePath({ rssd: bank.rssd, format: 'csv',
        periods: Object.keys(selectedPeriods),
        schedule_id,
      }) )
    }
  }, [ actionName, bank, schedule_id, selectedPeriods ])

  return <div className={`MainMenuW ${drawerOpen}`}>
    <ul className="PremainMenu">
      <li className="banks active">Banks</li>
      <li className='credit-unions'><Link to="/">Credit Unions</Link></li>
      <li className='holding-companies'><Link to="/">Holding Companies</Link></li>
    </ul>
    <div className='MainMenu'>
      <ul className='left'>

        <li className='banks-quick-search' onClick={() => {
          setActionName(C.queries_actions.create)
          setBanksSearchModalOpen(true)
        }}>
          <button className='Pushable'>
            <div className='front'><label>Bank Quick Search</label></div>
          </button>
        </li>

        <li className='single-fi-reports'
            onClick={() => setReportsModalOpen(true)}
        ><button className='Pushable '><div className='front'><label>Single FI Reports</label></div></button></li>

        <li className='multi-fi-reports'
            onClick={() => setAdvancedReportsModalOpen(true)}
        ><button className='Pushable '><div className='front'><label>Multi FI Reports</label></div></button></li>

        { (  C.actions['banks#schedule'] === actionName ||
           ( C.actions['banks#contacts'] === actionName && !unauthorized )
          ) ? <Link to={quickExportPath}><li className='quick-export' >
                <button className='Pushable'><div className='front'><label>Quick <br />Export</label></div></button>
              </li></Link>
            : <li className='quick-export'><button disabled={true} className='btn-disabled'><label>Quick <br />Export</label></button></li> }

        <li className='periods' onClick={() => setPeriodsModalOpen(true) } >
          <OverlayTrigger placement="left" show={!Object.keys(selectedPeriods).length}
              overlay={<Popover style={{ zIndex: 1 }} ><Popover.Body>Please select at least one <br />reporting period</Popover.Body></Popover>} >
            <button className={`Pushable`} >
              <div className='front'><label>Periods</label></div>
            </button>
          </OverlayTrigger>
        </li>

        <li className='saved-lists-queries' onClick={() => setQueriesModalOpen(true)}><button className='Pushable '><div className='front'><label>Saved Lists & Queries</label></div></button></li>

        <li onClick={() => {
          // setActionName(appRouter.banksResultsRoute)
          setFintegrationSearchModalOpen(true)
        }}>
          <button className='Pushable'>
            <div className='front'>Fintegration</div>
          </button>
        </li>

        <Link to={appRouter.docsShowPath()}>
          <li className='data-dictionary'>
            <button className='Pushable'
              onClick={() => {
                setResults([])
              } }
            ><div className='front'>Data Dictionary</div></button>
          </li>
        </Link>

      </ul>
      <ul className='right'>
        <li className='joyride' >
          <button className='Pushable'
                  onClick={() => {
                    setJoyrideStepIdx(0)
                    setJoyrideRun(true)
                    setJoyrideOpen(true)
                  } } >
            <div className='front'><label>Tour the App</label></div>
          </button>
        </li>
        <li onClick={nextTheme} >
          <button className='ThemeBtn Pushable'><div className='front'>
            {/* Change Theme<br /> */}
            {themeLabels[themeName]}</div></button>
        </li>
        { cuEmail && <li><button className='Pushable'
            onClick={() => setLogoutModalOpen(true) }
          ><div className='front'>Logout <br />{ `${cuEmail.split('@')[0]}` } <br />{ `@${cuEmail.split('@')[1]}` }</div></button>
        </li> }
      </ul>
    </div>

    <Modal
      ariaHideApp={false}
      className="LogoutModal BaseModal DoL"
      isOpen={logoutModalOpen}
      onRequestClose={ () => setLogoutModalOpen(false) }
      overlayClassName="ReportsModalOverlay"
    >
      <div className='header'>
        <h5 >Logout?</h5>
        <div className='close' onClick={() => setLogoutModalOpen(false)}>&times;</div>
      </div>
      <div className='modal-body'>
        <br /><br /><br />
        <button onClick={() => logout() }>Logout</button>
      </div>
    </Modal>

  </div>
}
export default MainMenu
